import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE } from "../utils/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "../pages/Product/Price.css";

function ProductAvailability() {
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };


  const flattenData = products.map((item) => ({
    productNumber: item.productNumber,
    productName: item.productName,
    categoryName: item.categoryName,
    subcategoryName: item.subcategoryName,
    variantName: item.variantName,
    unit: item.unit,
    quantity: item.quantity,
    batchAvailability: item.batchAvailability,
    isVisible: item.isVisible

  }));

  const filteredProducts = flattenData.filter(
    (item) =>
      item.productName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.productNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.categoryName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.subcategoryName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/products/availability?limit=0`);
        setProducts(response.data.products);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  const getCurrentDateTime = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const exportAvailability = () => {
    const doc = new jsPDF();
    doc.text(`Product_Available - ${getCurrentDateTime()}`, 10, 10);

    const tableData = flattenData.map((item) => [
      item.productNumber,
      item.productName,
      item.categoryName,
      item.subcategoryName,
      item.quantity,
      item.unit,

      Array.isArray(item.batchAvailability)
        ? item.batchAvailability.join("\n")
        : item.batchAvailability || "-",
      item.isVisible ? "Available" : "Not Available",
    ]);


    doc.autoTable({
      startY: 20,
      head: [
        [
          "Product Number",
          "Product Name",
          "Category",
          "Subcategory",
          "Unit",
          "Quantity",
          "Batch & Stock",
          "Status",
        ],
      ],
      body: tableData,
      styles: {
        fontSize: 9,
        cellPadding: 3,
        valign: "middle",
      },
      headStyles: {
        fillColor: [22, 160, 133],
        textColor: 255,
        fontStyle: "bold",
      },
      bodyStyles: {
        lineColor: [240, 240, 240],
        lineWidth: 0.2,
      },
      columnStyles: {
        6: { cellWidth: 30 },
        7: { halign: "center" },
      },
    });



    doc.save("Product_Availability.pdf");
  };

  const responsiveColumnHeader = (header, field) => (rowData) => (
    <div className="responsive-cell">
      <span className="responsive-header">{header}</span>
      <span className="responsive-value">{rowData[field]}</span>
    </div>
  );

  const batchAvailabilityBody = (rowData) => (
    <div className="responsive-cell">

      <span className="responsive-header">Batch & Stock</span>

      <span className="responsive-value" style={{ whiteSpace: "pre-line", textAlign: "left" }}>
        {Array.isArray(rowData.batchAvailability)
          ? rowData.batchAvailability.map((line, index) => (
            <div key={index}>{line}</div>
          ))
          : rowData.batchAvailability}
      </span>
    </div>
  );
  const statusTemplate = (rowData) => (
    <span
      style={{
        color: rowData.isVisible ? "green" : "red",
        fontWeight: "bold",
      }}
    >
      {rowData.isVisible ? "Available" : "Not Available"}
    </span>
  );

  return (
    <Box sx={{ fontFamily: "Times New Roman" }}>
      <h1>Product Availability</h1>

      {/* Search Box */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: "20%",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "15px",
            fontFamily: `"Times New Roman", Times, serif`,
          }}
        />
      </div>


      <Box mb={2} mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={exportAvailability}
          sx={{
            fontFamily: "Roboto",
            marginTop: "10px",
            minWidth: "100px",
            height: "40px",
          }}
        >
          Export All
        </Button>
      </Box>


      <DataTable
        value={filteredProducts}
        scrollable
        scrollHeight="450px"
        paginator
        rows={10}
        emptyMessage="No products found"
        className="datatable-scrollable"
      >
        <Column
          field="productNumber"
          header="Product Number"
          body={responsiveColumnHeader("Product Number", "productNumber")}
        />
        <Column
          field="productName"
          header="Product Name"
          body={responsiveColumnHeader("Product Name", "productName")}
        />
        <Column
          field="categoryName"
          header="Category"
          body={responsiveColumnHeader("Category", "categoryName")}
        />
        <Column
          field="subcategoryName"
          header="Subcategory"
          body={responsiveColumnHeader("Subcategory", "subcategoryName")}
        />
        <Column
          field="quantity"
          header="Quantity"
          body={responsiveColumnHeader("Quantity", "quantity")}
        />
        <Column
          field="unit"
          header="Unit"
          body={responsiveColumnHeader("Unit", "unit")}
        />

        <Column
          field="batchAvailability"
          header="Batch & Stock"
          body={batchAvailabilityBody}
        />
        <Column
          header="Status"
          body={statusTemplate}
          style={{ minWidth: "120px", textAlign: "center" }}
        />
      </DataTable>
    </Box>
  );
}

export default ProductAvailability;
